import ApiHelper from './apiHelper';

export default class ManagerDataApi {
    static async getFunds (): Promise<{ data: unknown }> {
        const response = await ApiHelper.get('FundsWithLatestGrade');
        return response;
    }
}
